export default __webpack_public_path__ + "static/logo-041125813d61c8c6772a55cf3423686f.svg";